// extracted by mini-css-extract-plugin
export default {"wrapper":"TotalBalance_wrapper_a51fa"};